import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      maxWidth: `calc(100%  - ${theme.spacing(3)}px)`,
      columnGap: theme.spacing(0.5),
      alignItems: 'center',
    },
    icon: {
      color: COLORS.gray.gray30,
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(20),
    },
    tag: {
      display: 'inline-block',
      backgroundColor: COLORS.gray.gray80,
      color: COLORS.gray.gray40,
      marginLeft: theme.spacing(0.5),
      textTransform: 'unset',
      padding: theme.spacing(0.25, 0.75),
      ...theme.typography.medium12,
    },
    customModelTag: {
      backgroundColor: COLORS.warning.light,
      color: COLORS.gray.black,
    },
    label: {
      color: COLORS.gray.gray40,
    },
    disabledText: {
      color: COLORS.gray.gray30,
    },
    emptyLabel: {
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'ToneOfVoiceLabel' }
);
